/**
 * Sticky time gutter: static hour labels plus a focus time chip that tracks
 * the keyboard cursor (subscribes to slotMin only).
 */
import React from "react";
import { MCGridConfig, MCInteractionState } from "./model/types";
import { hourMarks, minutesToTime, yForMin } from "./model/gridGeometry";
import { MiniStore, useMiniSelector } from "./model/miniStore";

interface TimeGutterProps {
  cfg: MCGridConfig;
  store: MiniStore<MCInteractionState>;
}

const HourLabels: React.FC<{ cfg: MCGridConfig }> = React.memo(({ cfg }) => (
  <>
    {hourMarks(cfg).map((min) => (
      <span key={min} className="mc-gutter-hour" style={{ top: yForMin(cfg, min) }}>
        {minutesToTime(min)}
      </span>
    ))}
  </>
));
HourLabels.displayName = "HourLabels";

const FocusTimeChip: React.FC<TimeGutterProps> = ({ cfg, store }) => {
  const slotMin = useMiniSelector(store, (s) => s.focus?.slotMin ?? null);
  if (slotMin == null) return null;
  return (
    <span className="mc-gutter-focus" style={{ top: yForMin(cfg, slotMin) }}>
      {minutesToTime(slotMin)}
    </span>
  );
};

const TimeGutter: React.FC<TimeGutterProps> = ({ cfg, store }) => (
  <>
    <HourLabels cfg={cfg} />
    <FocusTimeChip cfg={cfg} store={store} />
  </>
);

export default React.memo(TimeGutter);
